import { ShapeSquarePlusIcon } from './ShapeSquarePlusIcon';

/**
 * author: Kai Faust
 * id 56A31026-C5C6-45D5-A9D4-1C660357F430
 * name shape-square-plus
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shape-square-plus.svg
 * tags
 * - Shape 
 */
export const ShapeSquareAddIcon = ShapeSquarePlusIcon;
export default ShapeSquareAddIcon